module.exports = __webpack_public_path__ + "static/img/spring_lihuaPic.77e6e4a8.png";